import { isNil } from 'lodash'
import { time2Pixel, pixel2Time } from '~/Util'
import { DIRECTION } from '~/enums'
import { getIntersectionData } from './getIntersectionData'

const dockAssets = ({
  historyX,
  staticAssets,
  layers,
  scale,
  leftXOffset,
  draggableAssets,
  offsetLayerIndex,
  moveDirection,
  shiftingDragAssets,
  isExternalSource,
  draggableBlockDuration,
}) => {
  let freeSpace = null
  staticAssets.forEach(sAsset => {
    draggableAssets.forEach(dAsset => {
      if (sAsset.layerId === layers[(dAsset.layerIndex ?? 0) + offsetLayerIndex]?.id) {
        let diff = 0
        if (moveDirection === DIRECTION.LEFT) {
          const endTime = isExternalSource ? draggableBlockDuration : dAsset.endTime
          diff = sAsset.startTime - (endTime + shiftingDragAssets)
        } else if (moveDirection === DIRECTION.RIGHT) {
          diff = (dAsset.startTime + shiftingDragAssets) - sAsset.endTime
        }
        if (isNil(freeSpace)) {
          freeSpace = diff
        }
        freeSpace = Math.min(freeSpace, diff)
      }
    })
  })
  freeSpace = moveDirection === DIRECTION.LEFT ? freeSpace : freeSpace * -1
  const newTimeX = draggableAssets[0].startTime + shiftingDragAssets + freeSpace
  const stopDragLeftX = time2Pixel(newTimeX, scale) + leftXOffset
  if (stopDragLeftX >= 0) {
    // eslint-disable-next-line no-param-reassign
    historyX.current = {
      ...historyX.current,
      readyForDrop: true,
      draggableBlockLeftX: stopDragLeftX,
      stopDragLeftX,
    }
  }
}

// When moving the mouse pointer away from static assets, the draggable assets are moved forward
export const setQuickOffset = ({
  draggableAssets,
  historyX,
  moveDirection,
  scale,
  staticAssets,
  layers,
  clientMousePosition,
  isExternalSource,
  draggableBlockDuration,
  shiftingDragAssets,
  isMouseOver,
  dragItem,
  initialClientOffset,
  leftXOffset,
  intersectionPlaceholder,
  insertBetween,
  offsetLayerIndex,
  isOverlapped,
}) => {
  const checkedLayerIndex = isExternalSource
    ? offsetLayerIndex
    : dragItem.layerIndex + offsetLayerIndex
  const isPlaceholder = intersectionPlaceholder || insertBetween
  if (!isMouseOver && isOverlapped && !isPlaceholder && historyX.current.isMountedOnLayer) {
    // quickOffset - offset moves the block of dragged assets to a place where the mouse does not overlap with the assets
    let quickOffset = 0
    const initialNanoSecX = pixel2Time(
      (isExternalSource ? 0 : initialClientOffset.x) - leftXOffset, scale
    )
    if (moveDirection === DIRECTION.LEFT) {
      quickOffset = isExternalSource
        ? draggableBlockDuration * -1
        : (draggableAssets.at(-1).endTime - initialNanoSecX) * -1
    } else if (moveDirection === DIRECTION.RIGHT) {
      quickOffset = isExternalSource ? 0 : initialNanoSecX - draggableAssets[0].startTime
    }

    const { isOverlapped: shiftOverlapped } = getIntersectionData({
      staticAssets,
      draggableAssets,
      layers,
      shiftingDragAssets: shiftingDragAssets + quickOffset,
      offsetLayerIndex,
      isExternalSource,
      draggableBlockDuration,
      clientMousePosition,
      checkedLayerIndex,
      dragItem,
    })
    // найти минимальное расстояние между ассетами и сократить его до 0

    if (!shiftOverlapped) {
      dockAssets({
        historyX,
        staticAssets,
        layers,
        scale,
        leftXOffset,
        draggableAssets,
        offsetLayerIndex,
        moveDirection,
        shiftingDragAssets: shiftingDragAssets + quickOffset,
        isExternalSource,
        draggableBlockDuration,
      })
    }
  }
}
